if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';

        this.storageKey = 'dawn:recently-viewed';

        const ids = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        const limit = parseInt(this.dataset.limit, 25) || 7;
        const sectionId = this.dataset.sectionId;

        if (!ids.length || !sectionId) {
          this.remove();
          return;
        }

        const query = ids
          .slice(0, limit)
          .map(id => `id:${id}`)
          .join(' OR ');

        fetch(`/search?section_id=${sectionId}&type=product&q=${encodeURIComponent(query)}`)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('recently-viewed-products');

            if (!fresh) {
              this.remove();
              return;
            }
            //Replace inner HTML
            this.innerHTML = fresh.innerHTML;
            //IMPORTANT: Reinitialize quick-add-bulk components
            this.reinitializeQuickAddBulk();

            //Enable / disable slider based on count
            this.enableSliderIfNeeded();

            //Re-init Dawn sliders
            this.initSliders();
          })
          .catch(() => this.remove());
      }

          reinitializeQuickAddBulk() {
            const initQuickAdd = () => {
              if (!window.Shopify) {
              // Retry after 100ms if Shopify not loaded yet
              setTimeout(initQuickAdd, 100);
              return;
              }
              // Find all quick-add-bulk elements and reinitialize them
              this.querySelectorAll('quick-add-bulk').forEach(quickAddElement => {
                // Check if already properly initialized
                if (!quickAddElement.dataset.initialized) {
                    const newElement = document.createElement('quick-add-bulk');
                    newElement.innerHTML = quickAddElement.innerHTML;
                    Object.keys(quickAddElement.dataset).forEach(key => {
                    newElement.dataset[key] = quickAddElement.dataset[key];
                    });
                    newElement.className = quickAddElement.className;
                    
                    quickAddElement.parentNode.replaceChild(newElement, quickAddElement);
                    newElement.dataset.initialized = 'true';
                    
                    // Re-bind quantity inputs
                    const quantityInputs = newElement.querySelectorAll('quantity-input');
                    quantityInputs.forEach(input => {
                    const event = new Event('change', { bubbles: true });
                    input.dispatchEvent(event);
                    });
                }
              });
              // Notify Dawn that a section was loaded
              document.dispatchEvent(
                new CustomEvent('shopify:section:load', {
                    detail: { sectionId: this.dataset.sectionId }
                })
              );
              // Notify cart listeners
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            };
            // Start initialization
            setTimeout(initQuickAdd, 50);
          }
          
          enableSliderIfNeeded() {
            const sliderComponent = this.querySelector('slider-component');
            const grid = this.querySelector('.product-grid');
            const buttons = this.querySelector('.slider-buttons');
            if (!sliderComponent || !grid) return;
            // Disable slider if < 7 products
            // if (ids.length < 7) {
              //grid.classList.remove('slider', 'slider--desktop', 'slider--tablet');
            // sliderComponent.classList.remove('slider-component-desktop');
            // buttons?.remove();
            // return;
            // }

            // Enable slider if ≥ 7
            //grid.classList.add('slider', 'slider--desktop');
            //sliderComponent.classList.add('slider-component-desktop');
          }
          initSliders() {
            this.querySelectorAll('slider-component').forEach(slider => {
              if (typeof slider.init === 'function') {
                slider.init();
              }
            });
          }
    }
  );
}